import React from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import useStyles from './HeaderBlockStyles';
import { isMobile } from 'react-device-detect';

import {
    Container,
    Button,
    Grid,
    Card
} from '@mui/material';
import { zeroPad } from 'react-countdown';
import { Countdown } from "@/components/library/Countdown";
import useHistory from '../../../lib/hooks/useHistory';

interface Props {
    description?: string
    timerHeader?: string,
    timerDescription?: any,
    timerBtnText?: string,
    timerBtnSrc?: string,
    imageSrc: string
    settings: any,
}

const HeaderBlock: React.FC<Props> = (props) => {
    const {
        description,
        timerHeader,
        timerDescription,
        timerBtnText,
        timerBtnSrc,
        imageSrc,
        settings
    } = props;

    const { classes } = useStyles();
    const history = useHistory();
    const [countDownDate, setCountDownDate] = React.useState<any>(undefined);

    //React.useEffect(() => {
    //    if (overrideImgSrc === '' || overrideImgSrc === undefined) {
    //        setImgSrc(settings.VendorBannerUrl)
    //    } else {
    //        setImgSrc(overrideImgSrc)
    //    }
    //}, [settings])

    React.useEffect(() => {
        if (timerDescription) {
            var newCountDownDate = new Date(timerDescription);
            var newCountDownDateIsoString = newCountDownDate.toISOString();
            setCountDownDate(newCountDownDateIsoString);
        }
    }, [timerDescription])

    const timerBtnRoute = () => {
        if (timerBtnSrc) {
            history.push(timerBtnSrc)
        }
    }

    const CountdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) return <span className="pb-hero-open"><span />Now Open</span>;
        return (
            <div className="pb-hero-tiles">
                {[[days, "Days"], [hours, "Hrs"], [minutes, "Min"], [seconds, "Sec"]].map(([value, unit]) => (
                    <div key={unit as string}>
                        <strong>{zeroPad(value as number)}</strong>
                        <span>{unit}</span>
                    </div>
                ))}
            </div>
        );
    };

    const iosApp = () => {
        window.open(settings.IOSAppUrl);
    }

    const androidApp = () => {
        window.open(settings.AndroidAppUrl);
    }

    const [greater, setGreater] = React.useState<boolean>(window.innerWidth > 1620);
    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 1620 && !greater)
                setGreater(true)
            else if (window.innerWidth <= 1620 && greater)
                setGreater(false)
        }

        window.addEventListener('resize', handleResize)
    })

    // Only a client-chosen colour strip under the banner; no default brand-colour band.
    function Bottombar() {
        return settings?.Styles?.OverrideBottomBarBackgroundColor ? <div style={{ height: 12, background: settings.Styles.OverrideBottomBarBackgroundColor }} /> : null;
    }

    return <>
        <div style={{ position: 'relative', height: '100%', width: '100%', backgroundImage: `url(${imageSrc})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', aspectRatio: '4', minHeight: isMobile ? undefined : (countDownDate && (settings.AndroidAppUrl || settings.IOSAppUrl)) ? 450 : countDownDate ? 300 : undefined }} >
            {!isMobile && (countDownDate || settings.AndroidAppUrl || settings.IOSAppUrl) && (
                <div className="pb-hero-cards">
                    {countDownDate && (
                        <div className="pb-hero-card pb-hero-next">
                            <div className="pb-hero-label">{timerHeader}</div>
                            <div className="pb-hero-title">{description}</div>
                            <Countdown date={countDownDate} renderer={CountdownRenderer} />
                            <button type="button" className="pb-btn pb-btn-primary" onClick={timerBtnRoute}>{timerBtnText}</button>
                        </div>
                    )}
                    {(settings.AndroidAppUrl || settings.IOSAppUrl) && (
                        <div className="pb-hero-card pb-hero-apps">
                            <div className="pb-hero-label">Get the app</div>
                            <div className="pb-hero-subtitle">Bid from anywhere on your phone</div>
                            <div className="pb-hero-badges">
                                {settings.AndroidAppUrl && <img onClick={androidApp} src={"https://storage.googleapis.com/prembid/google.png"} alt="Get it on Google Play" />}
                                {settings.IOSAppUrl && <img onClick={iosApp} src={"https://storage.googleapis.com/prembid/ios.png"} alt="Download on the App Store" />}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>

        <Bottombar />
    </>
}

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
})

const mapDispatchToProps = (dispatch: any) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderBlock);